export const JMS_KEYS = {
  accessToken: 'jms-accessToken',
  refreshToken: 'jms-refreshToken',
  user: 'jms-user',
  deviceSignature: 'jms-deviceSignature',
} as const;

const LEGACY_KEYS = ['accessToken', 'refreshToken', 'user', 'deviceSignature'];

export function clearLegacyAuthKeys(): void {
  try {
    LEGACY_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch {
    // noop — storage may be unavailable
  }
}
